<template>
    <div class="page invite-repairer">
      <div class="auth-header">
        <div class="container">
          <div class="logo">
            <router-link to="/login" class="logo-link"></router-link>
          </div>
        </div>
      </div>
      <div class="container">
        <br />
        <br />
        <h2>Select a Plan</h2>
        <br />
        <p class="title-text-small">Start with <span>FREE</span> today and continue using Repairshop for Free until you need more</p>
        <br />
            <div class="pages-block" data-pages-target="pricing">
                <div class="wrapper">
                    <div class="table-pricing">
                        <div class="table-block-first">
                            <div class="table-col-functional">
                                <div class="table-row-first"></div>
                              <div class="pricing-sticky-first-text">
                                Unlimited Users/Logins Role Management
                                <p class="pricing-table-text-memo">Assign each member a role, keep information for
                                  the office separate from what techs see. Pay No extra.</p>
                              </div>
                              <div>Photo and File Storage
                                <p class="pricing-table-text-memo">(Store Photos, PDFs of Supplier Parts
                                  quotes/invoices, sublet invoices & more.)</p>
                              </div>
                              <div>Estimating
                                <p class="pricing-table-text-memo">Manage Estimates, setup estimate templates
                                  to re-use, Create customised pick lists, digital integration with other systems
                                  like Insurers and Parts Price sourcing & more.)</p>
                              </div>
                              <div>Estimate Templates
                                <p class="pricing-table-text-memo">Save and manage repetitive estimates with labour and
                                  Parts. Apply them to write a quote in seconds.</p>
                              </div>
                              <div>Estimate Custom Lists and Groups
                                <p class="pricing-table-text-memo">Add more to speed to quoting.
                                  Create and manage custom groups of lines items to a quote. Fill missing operations
                                  form schedules.</p>
                              </div>
                              <div>Job Cards (Mobile/Tablet)
                                <p class="pricing-table-text-memo">(Give Strippers & fitters, Panel and Paint techs
                                  a job card that can be accessed from their mobile phone to mark off each line of
                                  the estimate as they complete repairs.)</p>
                              </div>
                              <div>Parts Management
                                <p class="pricing-table-text-memo">Let’s you manage purchases on parts and
                                  consumables with suppliers.</p>
                              </div>
                              <div>Invoicing
                                <p class="pricing-table-text-memo">(Create and manage your invoices, send
                                  to insurers and private customers.)</p>
                              </div>
                              <div>Vehicle In Board
                                <p class="pricing-table-text-memo">Display vehicles on-site, progress & more.</p>
                              </div>
                              <div>Departure Board
                                <p class="pricing-table-text-memo">Display vehicle for final inspection.</p>
                              </div>
                              <div>Bookings Board
                                <p class="pricing-table-text-memo">Calendar manage inspections, estimate bookings and more.</p>
                              </div>
                              <div>ORM – Connect
                                <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                              </div>
                              <div>Estimage - Connect
                                <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                              </div>
                              <div>Audatex – Connect
                                <p class="pricing-table-text-memo">Direct sync claims / estimate.<br>
                                  (Audanet, Audabridge, Qaptor.)</p>
                              </div>
                              <div class="table-element-large">Audawatch – Connect
                                <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                              </div>
                              <div class="table-element-large">Repx – Connect
                                <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                              </div>
                              <div class="table-element-large">ORM Batch Invoicing
                              </div>
                              <div class="table-element-large">Auto Parts Receipting
                                <p class="pricing-table-text-memo">Ai intelligent parts invoicing reconciliation.</p>
                              </div>
                              <div class="table-row-last">Estimate Transfer
                                <p class="pricing-table-text-memo">Transfer estimates between accounts.</p>
                              </div>
                            </div>
                            <div class="table-col-free">
                                <div class="table-row-first">
                                    <div class="table-row-first-name">
                                        <p class="pricing-table-title">FREE</p>
                                        <p class="pricing-table-text">For students or shops need to create private quotes.</p>
                                    </div>
                                    <div class="pricing-table-link">
                                        <p class="pricing-table-price">$0.00/<span>month</span></p>
                                        <button href="#" @click="nextPageOfRegistration('free')">Select</button>
                                    </div>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                  <p class="pricing-table-text-memo">Unlimited User/Logins</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                    <p class="pricing-table-text-memo">(Includes 5MB data)</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                  <p class="pricing-table-text-memo">(Limited to 5)</p>
                                </div>
                                <div></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div class="table-element-large"></div>
                                <div class="table-element-large"></div>
                                <div class="table-element-large"></div>
                                <div class="table-element-large"></div>
                                <div class="table-row-last"></div>
                            </div>
                        </div>
                        <div class="table-block">
                            <div class="table-col-functional-column">
                                <div class="table-row-first"></div>
                                <div class="pricing-sticky-first-text">Unlimited Users/Logins Role Management
                                  <p class="pricing-table-text-memo">Assign each member a role, keep information for
                                    the office separate from what techs see. Pay No extra.</p>
                                </div>
                                <div>Photo and File Storage
                                  <p class="pricing-table-text-memo">(Store Photos, PDFs of Supplier Parts
                                    quotes/invoices, sublet invoices & more.)</p>
                                </div>
                                <div>Estimating
                                  <p class="pricing-table-text-memo">Manage Estimates, setup estimate templates
                                    to re-use, Create customised pick lists, digital integration with other systems
                                    like Insurers and Parts Price sourcing & more.)</p>
                                </div>
                                <div>Estimate Templates
                                  <p class="pricing-table-text-memo">Save and manage repetitive estimates with labour and
                                    Parts. Apply them to write a quote in seconds.</p>
                                </div>
                                <div>Estimate Custom Lists and Groups
                                  <p class="pricing-table-text-memo">Add more to speed to quoting.
                                    Create and manage custom groups of lines items to a quote. Fill missing operations
                                    form schedules.</p>
                                </div>
                                <div>Job Cards (Mobile/Tablet)
                                  <p class="pricing-table-text-memo">(Give Strippers & fitters, Panel and Paint techs
                                    a job card that can be accessed from their mobile phone to mark off each line of
                                    the estimate as they complete repairs.)</p>
                                </div>
                                <div>Parts Management
                                  <p class="pricing-table-text-memo">Let’s you manage purchases on parts and
                                    consumables with suppliers.</p>
                                </div>
                                <div>Invoicing
                                  <p class="pricing-table-text-memo">(Create and manage your invoices, send to
                                    insurers and private customers.)</p>
                                </div>
                                <div>Vehicle In Board
                                  <p class="pricing-table-text-memo">Display vehicles on-site, progress & more.</p>
                                </div>
                                <div>Departure Board
                                  <p class="pricing-table-text-memo">Display vehicle for final inspection.</p>
                                </div>
                                <div>Bookings Board
                                  <p class="pricing-table-text-memo">Calendar manage inspections, estimate bookings and more.</p>
                                </div>
                                <div>ORM – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                                </div>
                                <div>Estimage - Connect
                                  <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                                </div>
                                <div>Audatex – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims / estimate.<br>
                                    (Audanet, Audabridge, Qaptor.)</p>
                                </div>
                                <div class="table-element-large">Audawatch – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                                </div>
                                <div class="table-element-large">Repx – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                                </div>
                                <div class="table-element-large">ORM Batch Invoicing
                                </div>
                                <div class="table-element-large">Auto Parts Receipting
                                  <p class="pricing-table-text-memo">Ai intelligent parts invoicing reconciliation.</p>
                                </div>
                                <div class="table-row-last">Estimate Transfer
                                  <p class="pricing-table-text-memo">Transfer estimates between accounts.</p>
                                </div>
                            </div>
                            <div class="table-col-level1">
                                <div class="table-row-first">
                                    <div class="table-row-first-name">
                                        <p class="pricing-table-title">Basic</p>
                                        <p class="pricing-table-text">For business wanting to process estimates for insurers and reconcile invoicing.</p>
                                    </div>
                                    <div class="pricing-table-link">
                                        <p class="pricing-table-price">$50/<span>month</span></p>
                                        <button href="#" @click="nextPageOfRegistration('pack-1')">Select</button>
                                    </div>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                  <p class="pricing-table-text-memo">Unlimited User/Logins</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                    <p class="pricing-table-text-memo">Unlimited Data</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                  <p class="pricing-table-text-memo">(Limited to 20)</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div class="table-element-large"></div>
                                <div class="table-element-large"></div>
                                <div class="table-element-large"></div>
                                <div class="table-element-large"></div>
                                <div class="table-row-last"></div>
                            </div>
                        </div>
                        <div class="table-block">
                            <div class="table-col-functional-column">
                                <div class="table-row-first"></div>
                                <div class="pricing-sticky-first-text">Unlimited Users/Logins Role Management
                                  <p class="pricing-table-text-memo">Assign each member a role, keep information for
                                    the office separate from what techs see. Pay No extra.</p>
                                </div>
                                <div>Photo and File Storage
                                  <p class="pricing-table-text-memo">(Store Photos, PDFs of Supplier Parts
                                    quotes/invoices, sublet invoices & more.)</p>
                                </div>
                                <div>Estimating
                                  <p class="pricing-table-text-memo">Manage Estimates, setup estimate templates
                                    to re-use, Create customised pick lists, digital integration with other systems
                                    like Insurers and Parts Price sourcing & more.)</p>
                                </div>
                                <div>Estimate Templates
                                  <p class="pricing-table-text-memo">Save and manage repetitive estimates with labour and
                                    Parts. Apply them to write a quote in seconds.</p>
                                </div>
                                <div>Estimate Custom Lists and Groups
                                  <p class="pricing-table-text-memo">Add more to speed to quoting.
                                    Create and manage custom groups of lines items to a quote. Fill missing operations
                                    form schedules.</p>
                                </div>
                                <div>Job Cards (Mobile/Tablet)
                                  <p class="pricing-table-text-memo">(Give Strippers & fitters, Panel and Paint techs
                                    a job card that can be accessed from their mobile phone to mark off each line of
                                    the estimate as they complete repairs.)</p>
                                </div>
                                <div>Parts Management
                                  <p class="pricing-table-text-memo">Let’s you manage purchases on parts and
                                    consumables with suppliers.</p>
                                </div>
                                <div>Invoicing
                                  <p class="pricing-table-text-memo">(Create and manage your invoices,
                                    send to insurers and private customers.)</p>
                                </div>
                                <div>Vehicle In Board
                                  <p class="pricing-table-text-memo">Display vehicles on-site, progress & more.</p>
                                </div>
                                <div>Departure Board
                                  <p class="pricing-table-text-memo">Display vehicle for final inspection.</p>
                                </div>
                                <div>Bookings Board
                                  <p class="pricing-table-text-memo">Calendar manage inspections, estimate bookings and more.</p>
                                </div>
                                <div>ORM – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                                </div>
                                <div>Estimage - Connect
                                  <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                                </div>
                                <div>Audatex – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims / estimate.<br>
                                    (Audanet, Audabridge, Qaptor.)</p>
                                </div>
                                <div class="table-element-large">Audawatch – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                                </div>
                                <div class="table-element-large">Repx – Connect
                                  <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                                </div>
                                <div class="table-element-large">ORM Batch Invoicing
                                </div>
                                <div class="table-element-large">Auto Parts Receipting
                                  <p class="pricing-table-text-memo">Ai intelligent parts invoicing reconciliation.</p>
                                </div>
                                <div class="table-row-last">Estimate Transfer
                                  <p class="pricing-table-text-memo">Transfer estimates between accounts.</p>
                                </div>
                            </div>
                            <div class="table-col-level2">
                                <div class="table-row-first">
                                    <div class="table-row-first-name">
                                        <p class="pricing-table-title">Premium</p>
                                        <p class="pricing-table-text">For Small to Medium volume repairers wanting all
                                            features plus email and phone support with priority escalation.</p>
                                    </div>
                                    <div class="pricing-table-link">
                                        <p class="pricing-table-price">$150/<span>month</span></p>
                                        <button href="#" @click="nextPageOfRegistration('pack-2')">Select</button>
                                    </div>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                  <p class="pricing-table-text-memo">Unlimited User/Logins</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                    <p class="pricing-table-text-memo">Unlimited Data</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                  <p class="pricing-table-text-memo">(Unlimited - Templates)</p>
                                </div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                                <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                              <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                <p class="pricing-table-text-memo">Coming soon</p>
                              </div>
                              <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                <p class="pricing-table-text-memo">Coming soon</p>
                              </div>
                              <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                <p class="pricing-table-text-memo">Coming soon</p>
                              </div>
                              <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                <p class="pricing-table-text-memo">$30 +GST p/m</p>
                              </div>
                              <div class="table-row-last"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                                <p class="pricing-table-text-memo">$15 +GST p/m</p>
                              </div>
                            </div>
                        </div>
                        <div class="table-block">
                        <div class="table-col-functional-column">
                          <div class="table-row-first"></div>
                          <div class="pricing-sticky-first-text">Unlimited Users/Logins Role Management
                            <p class="pricing-table-text-memo">Assign each member a role, keep information for
                              the office separate from what techs see. Pay No extra.</p>
                          </div>
                          <div>Photo and File Storage
                            <p class="pricing-table-text-memo">(Store Photos, PDFs of Supplier Parts
                              quotes/invoices, sublet invoices & more.)</p>
                          </div>
                          <div>Estimating
                            <p class="pricing-table-text-memo">Manage Estimates, setup estimate templates
                              to re-use, Create customised pick lists, digital integration with other systems
                              like Insurers and Parts Price sourcing & more.)</p>
                          </div>
                          <div>Estimate Templates
                            <p class="pricing-table-text-memo">Save and manage repetitive estimates with labour and
                              Parts. Apply them to write a quote in seconds.</p>
                          </div>
                          <div>Estimate Custom Lists and Groups
                            <p class="pricing-table-text-memo">Add more to speed to quoting.
                              Create and manage custom groups of lines items to a quote. Fill missing operations
                              form schedules.</p>
                          </div>
                          <div>Job Cards (Mobile/Tablet)
                            <p class="pricing-table-text-memo">(Give Strippers & fitters, Panel and Paint techs
                              a job card that can be accessed from their mobile phone to mark off each line of
                              the estimate as they complete repairs.)</p>
                          </div>
                          <div>Parts Management
                            <p class="pricing-table-text-memo">Let’s you manage purchases on parts and
                              consumables with suppliers.</p>
                          </div>
                          <div>Invoicing
                            <p class="pricing-table-text-memo">(Create and manage your invoices,
                              send to insurers and private customers.)</p>
                          </div>
                          <div>Vehicle In Board
                            <p class="pricing-table-text-memo">Display vehicles on-site, progress & more.</p>
                          </div>
                          <div>Departure Board
                            <p class="pricing-table-text-memo">Display vehicle for final inspection.</p>
                          </div>
                          <div>Bookings Board
                            <p class="pricing-table-text-memo">Calendar manage inspections, estimate bookings and more.</p>
                          </div>
                          <div>ORM – Connect
                            <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                          </div>
                          <div>Estimage - Connect
                            <p class="pricing-table-text-memo">Direct sync claims / estimates.</p>
                          </div>
                          <div>Audatex – Connect
                            <p class="pricing-table-text-memo">Direct sync claims / estimate.<br>
                              (Audanet, Audabridge, Qaptor.)</p>
                          </div>
                          <div class="table-element-large">Audawatch – Connect
                            <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                          </div>
                          <div class="table-element-large">Repx – Connect
                            <p class="pricing-table-text-memo">Direct sync claims progress with updates and more..</p>
                          </div>
                          <div class="table-element-large">ORM Batch Invoicing
                          </div>
                          <div class="table-element-large">Auto Parts Receipting
                            <p class="pricing-table-text-memo">Ai intelligent parts invoicing reconciliation.</p>
                          </div>
                          <div class="table-row-last">Estimate Transfer
                            <p class="pricing-table-text-memo">Transfer estimates between accounts.</p>
                          </div>
                        </div>
                        <div class="table-col-level2">
                          <div class="table-row-first">
                            <div class="table-row-first-name">
                              <p class="pricing-table-title">Multi-site</p>
                              <p class="pricing-table-text">For Medium to large collision repairers wanting all
                                features plus email and phone support with priority escalation.</p>
                            </div>
                            <div class="pricing-table-link">
                              <p class="pricing-table-price">$400/<span>month</span></p>
                              <button href="#" @click="nextPageOfRegistration('pack-3')">Select</button>
                            </div>
                          </div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">Unlimited User/Logins</p>
                          </div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">Unlimited Data</p>
                          </div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">(Unlimited - Templates)</p>
                          </div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div><i class='bx bxs-checkbox-checked checkbox-checked'></i></div>
                          <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">Coming soon</p>
                          </div>
                          <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">Coming soon</p>
                          </div>
                          <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">Coming soon</p>
                          </div>
                          <div class="table-element-large"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">$30 +GST p/m</p>
                          </div>
                          <div class="table-row-last"><i class='bx bxs-checkbox-checked checkbox-checked'></i>
                            <p class="pricing-table-text-memo">$15 +GST p/m</p>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
  export default {
    name: "selectPlan",
    props: {
      user: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
      }
    },
    mounted() {

    },
    methods: {
        nextPageOfRegistration: function(pack) {
          this.$router.push({
            name: 'Registration',
            params: {
              user: this.$route.params.user,
              support_pack: pack,
            }
          });
        },
    },
    computed: {
    }
  }
  </script>

  <style scoped>
    .pricing-table-text-memo ul{
      margin-left: 20px;
    }
    .invite-repairer-form h3 {
      max-width: 500px;
      margin: 0 auto;
      margin-top: 50px;
    }

    .auth-header {
      background-color: #1f233d;
      height: 100px;
      position: sticky;
      top: 0;
      z-index: 1000;
    }

    .logo-text {
      color: white;
    }

    .container {
      height: 100%;
    }

    .logo {
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 72px;
    }

    .logo-link {
          display: block;
          height: 42px;
          width: 200px;
          background: url('data:image/gif;base64,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')
      }
  </style>

<style scoped>

    /* --MAIN PRICING-- */

.container {
    width: 1440px;
    margin: 0 auto;
}

.wrapper {
    margin: 0 auto;
    padding: 32px 72px 0 72px;
}

hr {
    border: 1px solid #484848;
}

h2 {
    text-align: center;
    font-size: 32px;
    font-weight: 800;
    letter-spacing: -0.5px;
    line-height: 43px;
}

.title-text-small {
    text-align: center;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 32px;
}

.table-pricing {
    display: flex;
}

.table-pricing .table-block-first {
    display: flex;
}

.table-block-first {
    width: 40%;
}

.table-block {
    width: 20%;
}

.table-col-functional,
.table-col-free {
    width: 50%;
}

.table-row-first {
    height: 397px !important;
    justify-content: space-between !important;
}

.pricing-table-link {
    height: auto !important;
    margin-bottom: 20px !important;
}

.table-col-free {
    background: #F7F7FF;
}

.table-col-functional {
    text-align: left;
    color: #212524;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 24px;
}

.table-col-functional div {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 170px;
    border-bottom: 1px solid #E9E9E9;
    padding-right: 15px;
    flex-direction: column;

}

.table-row-first-name{
  display: block; padding: 20px 0; border-bottom: none !important
}
.table-col-free div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 170px;
    border-bottom: 1px solid #E9E9E9;
    padding: 0 27px;
}

.table-col-level1 div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 170px;
    border-bottom: 1px solid #E9E9E9;
    padding: 0 27px;
}

.table-col-level2 div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 170px;
    border-bottom: 1px solid #E9E9E9;
    padding: 0 27px;
}

.table-row-first {
    border-bottom: 1px solid white !important;
}

.pricing-table-title {
    color: #212524;
    font-family: "Nunito Sans";
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 32px;
    height: 30px;
    white-space: nowrap;
}

.pricing-table-text {
    color: black;
    font-family: "Nunito Sans";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 22px;
    margin-top: 16px;
    min-height: 100px;
}

.pricing-table-text-memo {
    margin-top: 10px;
    color: #111324;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
    margin-bottom: 0;
}

.pricing-table-price {
    color: black;
    font-family: "Nunito Sans";
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 32px;
    margin-bottom: 15px;
}

.pricing-table-price span {
  font-weight: 700;
  font-size: 21px;
}

.pricing-table-link {
    display: flex;
    align-items: flex-start;
    padding-left: 0 !important;
    border-bottom: none !important;
}

.table-row-last {
    border-bottom: none !important;
}

.pricing-table-link button {
    color: #544BEE;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.28px;
    line-height: 24px;
    text-align: center;
    border-radius: 4px;
    padding: 15px 30px;
    border: 2px solid #544BEE;
}

.table-col-free .pricing-table-link button {
    background: linear-gradient(135deg, #7267E7 0%, #6259EF 49.12%, #4E45EE 100%);
    color: #FFFFFF;
    border: none;
}

.table-col-level1:hover .pricing-table-link button {
    background: linear-gradient(135deg, #7267E7 0%, #6259EF 49.12%, #4E45EE 100%);
    color: #FFFFFF;
    border: none;
}

.table-col-level2:hover .pricing-table-link button {
    background: linear-gradient(135deg, #7267E7 0%, #6259EF 49.12%, #4E45EE 100%);
    color: #FFFFFF;
    border: none;
}

.checkbox-checked {
    color: #00b050;
    font-size: 30px;
}

.table-element-large {
    height: 140px !important;
}

.table-addons {
    display: flex;
    margin: 42px 0;
}

.addons-col-functional {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 25%;
    text-align: left;
    color: #212524;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 24px;
}

.table-col-functional-column {
    display: none;
}

.addons-col-price {
    width: 75%;
    display: flex;
    flex-direction: column;
    color: #00B050;
    font-family: "Nunito Sans";
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 27px;
}

.addons-col-functional div,
.addons-col-price div {
    display: flex;
    align-items: center;
    height: 84px;
    border-bottom: 1px solid #E9E9E9;
    padding-right: 27px;
}

.addons-col-price div {
    padding: 0 27px;
}

.addons-col-price div:hover {
    background: #F7F7FF;
}

.addons-table {
    margin: 42px 0;
    border-collapse: collapse;
    overflow: hidden;
}

.addons-table tbody tr th {
    width: 25%;
    text-align: left;
    color: #212524;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 24px;
    padding: 9px 27px 20px 0;
}

.addons-table tbody td {
    color: #00B050;
    font-family: "Nunito Sans";
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 27px;
    padding: 9px 27px 20px 27px;
}

.addons-table tbody tr {
    box-sizing: border-box;
    height: 1px;
    width: 1295px;
    border-bottom: 1px solid #E9E9E9;
}

.addons-table-active:hover {
    background: #F7F7FF;
}

.changeBtn {
    background-color: #111324 !important;
}

.table-row-first {
    position: sticky;
    top: 100px;
    background: white;
}

.table-col-free .table-row-first {
    background: #F7F7FF !important;
}

.table-row-first {
    border-bottom: none !important;
}

@media screen and (max-width: 1328px) {
    .wrapper{
      padding-left: 10px;
      padding-right: 10px;
    }
    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 180px;
    }
}

@media screen and (max-width: 1100px) {
    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 200px;
        padding: 0 15px;
    }
}

@media screen and (max-width: 991px) {
    .wrapper {
        padding: 20px 40px 0 40px;
    }

    .head-title {
        padding-right: 20px;
    }

    .head-title h1 {
        font-size: 25px;
    }

    .head-block {
        padding-top: 30px;
    }

    .main-block {
        flex-direction: column;
    }

    .main-block-reverse {
        flex-direction: column-reverse;
    }

    .main-block-text {
        text-align: center;
    }

    .main-block-vertical {
        flex-direction: column-reverse;
    }

    .main-block-vertical .main-block-text p {
        width: 500px;
    }

    .main-keep-me-posted-block {
        padding: 0 50px;
    }

    .table-element-large {
        height: 150px !important;
    }

    footer {
        height: auto;
    }

    .footer-block-left {
        width: 50%;
        padding-right: 40px;
    }

    .footer-block-right {
        flex-direction: column;
        width: 50%;
    }

    .about-block-text {
        width: 100%;
    }

    .footer-block-navigation {
        width: auto;
    }

    .copyright-text {
        padding-bottom: 20px;
    }
}

@media screen and (max-width: 865px) {
    .table-row-first {
        min-height: 500px !important;
    }

    .pricing-table-title {
        height: 100px !important;
    }

    .table-col-functional div {
        height: 240px;
    }

    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 240px;
    }

    .pricing-table-text {
        min-height: 200px;
    }

    .table-element-large {
        height: 160px !important;
    }
}

@media screen and (max-width: 1000px) {
    .table-col-functional-column div {
        flex-direction: column;
        align-items: flex-start !important;
    }

    .wrapper {
        padding: 20px 0;
    }
    .head-block {
        padding-top: 20px;
        flex-direction: column;
    }

    .head-title {
        padding: 0;
    }

    .head-title h1 {
        text-align: center;
        font-size: 20px;
    }

    .main-block-reverse div img,
    .main-block div img,
    .main-img img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
    }

    .main-img-double {
        display: none;
    }

    .main-block-vertical .main-block-text p,
    .main-block-text {
        width: 90%;
    }

    .main-block-text {
        margin-left: 0;
    }

    .table-pricing {
        flex-direction: column;
    }

    .table-block {
        display: flex;
    }

    .table-block-first,
    .table-block {
        width: 100%;
    }

    .table-col-free {
        background: none;
    }


    .pricing-table-link {
        height: auto;
    }

    .table-row-first {
        align-items: center;
        margin-left: -100%;
        text-align: center;
        height: 210px !important;
        min-height: 210px !important;
    }

    .table-row-first-name{
      padding: 5px 0 !important;
    }
    .pricing-table-link{
      margin-bottom: 5px !important;
    }
    .pricing-table-price{
      margin-bottom: 5px;
    }
    .pricing-table-title {
        height: 30px !important;
    }

    .pricing-table-text {
        min-height: 30px !important;
        width: 100%;
        margin-top: 0;
        margin-bottom: 10px;
    }

    .pricing-table-link {
        padding-right: 0 !important;
    }

    .table-block {
        margin-top: 30px;
    }

    .table-col-functional-column {
        display: block;
        text-align: left;
        color: #212524;
        font-family: "Nunito Sans";
        font-size: 18px;
        font-weight: 800;
        letter-spacing: 0;
        line-height: 24px;
        width: 50%;
    }

    .table-col-functional-column div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 86px;
        border-bottom: 1px solid #E9E9E9;
        padding-right: 27px;
    }

    .table-col-level1,
    .table-col-level2 {
        width: 50%;
    }

    .addons-col-functional,
    .addons-col-price {
        width: 50%;
    }

    .footer-container {
        flex-direction: column;
        margin: 0;
    }

    .footer-block-left,
    .footer-block-right {
        width: 90%;
        margin: 0 auto;
        padding: 20px 0;
    }

    .footer-block {
        text-align: center;
        margin-bottom: 30px;
    }

    .footer-block-navigation nav {
        justify-content: center;
    }

    .copyright-text {
        text-align: center;
    }

    .table-block-first:hover,
    .table-block:hover {
        background: #F7F7FF;
    }

    .main-block-reverse-mobile {
        display: flex;
    }
    .main-block-reverse-mobile {
        flex-direction: column;
    }

    .main-img-double-mobile,
    .main-img-three-mobile {
        display: flex;
        margin-top: 20px;
    }

    .img-mobile-first,
    .img-mobile-two {
        width: 50%;
    }

    .main-img-three-mobile img {
        display: flex;
        padding-left: 30px;
    }

    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 155px;
    }

    .table-col-functional div,
    .table-col-functional-column div {
        justify-content: center;
    }
}

@media screen and (max-width: 576px) {
    .head-menu {
        flex-direction: column;
    }

    .logo {
        margin-bottom: 50px;
    }

    .head-title {
        display: none;
    }

    .registration-block {
        width: 100%;
        margin-top: 20px;
    }

    .form-control {
        max-width: 100%;
    }

    .main-block-tabs {
        flex-direction: column;
        height: 150px;
        width: 150px;
    }

    .tabs-btn {
        width: 140px;
        text-align: center;
        padding-right: 0;
        padding-left: 0;
    }

    .main-register-link-block {
        align-items: center;
    }

    .main-register-link-block h4 {
        width: 90%;
    }

    .main-block-reverse div img,
    .main-block div img,
    .main-img img {
        display: none;
    }

    .main-img,
    .main-img-double {
        display: none;
    }

    .table-col-functional-column div,
    .table-col-level2 div,
    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div {
        height: 130px;
        padding-right: 0;
    }

    .table-row-first {
        padding: 0 !important;
    }

    .addons-col-functional div,
    .addons-col-price div {
        height: 120px;
    }

    .main-keep-me-posted-block {
        height: 100%;
        padding-top: 30px;
        padding-bottom: 30px;
    }

    .keep-me-posted-btn {
        margin-bottom: 20px;
    }
    .main-block-reverse-mobile {
        display: flex;
    }
    .main-block-reverse-mobile {
        flex-direction: column;
    }

    .main-img-double-mobile,
    .main-img-three-mobile {
        display: flex;
        margin-top: 20px;
    }

    .img-mobile-first,
    .img-mobile-two {
        width: 50%;
        display: block !important;
    }

    .main-img-three-mobile img {
        display: flex;
        padding-left: 30px;
    }

    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 200px;
    }
    .pricing-table-title{
      margin-bottom: 0;
    }
    .pricing-table-link button{
      height: 45px;
      padding: 10px 30px;
    }
}

@media screen and (max-width: 450px) {
    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 200px;
    }
}

@media screen and (max-width: 350px) {
    .table-row-first {
        min-height: 400px !important;
    }

    .table-block {
        margin-top: 100px;
    }

    .table-col-functional div,
    .table-col-free div,
    .table-col-level1 div,
    .table-col-level2 div,
    .table-col-functional-column div {
        height: 270px;
    }
}
</style>
